/**
 * PURPOSE: Contains logic related to the RateType Toggling.
 */

// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { DashMiddleware, DashNext, DashStore } from '@makemydeal/dr-shared-store';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { LEASE } from '@makemydeal/dr-platform-types';

// selectors
import * as offerSelectors from '../selectors/offerSelectors';
import * as rateTypeSelectors from '../selectors/rateTypeSelectors';

// consts/enums
import { SAVE_OFFER } from '../actionTypes/offerActionTypes';
import { TOGGLE_RATE_TYPE } from '../actionTypes/baseDealActionTypes';

// actions
import * as baseDealActionCreators from '../actions/baseDealActionCreators';

export const middleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    next(action);
    const state = store.getState();

    switch (action.type) {
        case SAVE_OFFER: {
            const rateType = offerSelectors.getRateTypeOverrideFromOfferTypeOrSelectedTerm(state);
            const referenceRateType = rateTypeSelectors.getReferenceRateType(state);
            const isDealCentralScreen = dealerSelectors.isDealCentralExperience(state);

            if (isDealCentralScreen && rateType !== referenceRateType) {
                store.dispatch(baseDealActionCreators.setReferenceRateType(rateType));
            }
            break;
        }
        case TOGGLE_RATE_TYPE: {
            const rateType = action.payload?.rateType;
            const isRedesignEnabled = featureToggleSelectors.isAspPaymentGridRedesignEnabled(state);
            const isDealCentralScreen = dealerSelectors.isDealCentralExperience(state);

            if (
                action.payload?.offerType === LEASE &&
                isRedesignEnabled &&
                isDealCentralScreen &&
                rateType &&
                rateType !== rateTypeSelectors.getReferenceRateType(state)
            ) {
                store.dispatch(baseDealActionCreators.setReferenceRateType(rateType));
            }
            break;
        }
        default:
            break;
    }
};
